export const uploaderOptions = {
  concurrency: 1
};
